/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * Refind API
 * API for Refind - A link inbox app for saving and searching links
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteLinksId200,
  DeleteLinksId400,
  DeleteLinksId404,
  GetLinks200,
  GetLinksParams,
  GetLinksSearch200,
  GetLinksSearch400,
  GetLinksSearchParams,
  PatchLinksIdFavorite200,
  PatchLinksIdFavorite400,
  PatchLinksIdFavorite404,
  PostLinks201,
  PostLinks400,
  PostLinksBody
} from '.././models';

import { customInstance } from '../../client';




/**
 * Creates a new link in the user's inbox. The URL is required and will be automatically normalized (adding https:// if missing). Metadata like title, description, image, and source are automatically extracted from the URL. You can optionally provide these fields to override the automatic extraction.
 * @summary Create a new link
 */
export const postLinks = (
    postLinksBody: PostLinksBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostLinks201>(
      {url: `/create-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postLinksBody, signal
    },
      );
    }
  


export const getPostLinksMutationOptions = <TError = PostLinks400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLinks>>, TError,{data: PostLinksBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postLinks>>, TError,{data: PostLinksBody}, TContext> => {

const mutationKey = ['postLinks'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLinks>>, {data: PostLinksBody}> = (props) => {
          const {data} = props ?? {};

          return  postLinks(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLinksMutationResult = NonNullable<Awaited<ReturnType<typeof postLinks>>>
    export type PostLinksMutationBody = PostLinksBody
    export type PostLinksMutationError = PostLinks400

    /**
 * @summary Create a new link
 */
export const usePostLinks = <TError = PostLinks400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLinks>>, TError,{data: PostLinksBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postLinks>>,
        TError,
        {data: PostLinksBody},
        TContext
      > => {

      const mutationOptions = getPostLinksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns a chronological list of links (most recent first). Supports pagination through limit and offset parameters. Default limit is 50, maximum is 100.
 * @summary List links
 */
export const getLinks = (
    params?: GetLinksParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLinks200>(
      {url: `/list-links`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLinksQueryKey = (params?: GetLinksParams,) => {
    return [
    `/links`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLinksQueryOptions = <TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(params?: GetLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinks>>> = ({ signal }) => getLinks(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000, refetchOnWindowFocus: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getLinks>>>
export type GetLinksQueryError = unknown


export function useGetLinks<TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(
 params: undefined |  GetLinksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinks>>,
          TError,
          Awaited<ReturnType<typeof getLinks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinks<TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(
 params?: GetLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinks>>,
          TError,
          Awaited<ReturnType<typeof getLinks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinks<TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(
 params?: GetLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List links
 */

export function useGetLinks<TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(
 params?: GetLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLinksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Search links by text in title, description, and URL. Query must be at least 2 characters. Case-insensitive search. Results are ordered chronologically (most recent first).
 * @summary Search links
 */
export const getLinksSearch = (
    params: GetLinksSearchParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLinksSearch200>(
      {url: `/search-links`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLinksSearchQueryKey = (params?: GetLinksSearchParams,) => {
    return [
    `/links/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLinksSearchQueryOptions = <TData = Awaited<ReturnType<typeof getLinksSearch>>, TError = GetLinksSearch400>(params: GetLinksSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinksSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinksSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinksSearch>>> = ({ signal }) => getLinksSearch(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000, refetchOnWindowFocus: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinksSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLinksSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getLinksSearch>>>
export type GetLinksSearchQueryError = GetLinksSearch400


export function useGetLinksSearch<TData = Awaited<ReturnType<typeof getLinksSearch>>, TError = GetLinksSearch400>(
 params: GetLinksSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinksSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinksSearch>>,
          TError,
          Awaited<ReturnType<typeof getLinksSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinksSearch<TData = Awaited<ReturnType<typeof getLinksSearch>>, TError = GetLinksSearch400>(
 params: GetLinksSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinksSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinksSearch>>,
          TError,
          Awaited<ReturnType<typeof getLinksSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinksSearch<TData = Awaited<ReturnType<typeof getLinksSearch>>, TError = GetLinksSearch400>(
 params: GetLinksSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinksSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search links
 */

export function useGetLinksSearch<TData = Awaited<ReturnType<typeof getLinksSearch>>, TError = GetLinksSearch400>(
 params: GetLinksSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinksSearch>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLinksSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Toggles the favorite status of a link. If the link is currently a favorite, it will be unfavorited. If it's not a favorite, it will be marked as favorite.
 * @summary Toggle link favorite status
 */
export const patchLinksIdFavorite = (
    id: string,
 ) => {
      
      
      return customInstance<PatchLinksIdFavorite200>(
      {url: `/toggle-favorite/${id}/favorite`, method: 'PATCH'
    },
      );
    }
  


export const getPatchLinksIdFavoriteMutationOptions = <TError = PatchLinksIdFavorite400 | PatchLinksIdFavorite404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLinksIdFavorite>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchLinksIdFavorite>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchLinksIdFavorite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchLinksIdFavorite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchLinksIdFavorite(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchLinksIdFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof patchLinksIdFavorite>>>
    
    export type PatchLinksIdFavoriteMutationError = PatchLinksIdFavorite400 | PatchLinksIdFavorite404

    /**
 * @summary Toggle link favorite status
 */
export const usePatchLinksIdFavorite = <TError = PatchLinksIdFavorite400 | PatchLinksIdFavorite404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLinksIdFavorite>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchLinksIdFavorite>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchLinksIdFavoriteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Permanently deletes a link from the user's inbox.
 * @summary Delete a link
 */
export const deleteLinksId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteLinksId200>(
      {url: `/delete-link/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteLinksIdMutationOptions = <TError = DeleteLinksId400 | DeleteLinksId404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLinksId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLinksId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLinksId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLinksId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLinksId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLinksIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLinksId>>>
    
    export type DeleteLinksIdMutationError = DeleteLinksId400 | DeleteLinksId404

    /**
 * @summary Delete a link
 */
export const useDeleteLinksId = <TError = DeleteLinksId400 | DeleteLinksId404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLinksId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLinksId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteLinksIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    